import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from '../modules/shared/shared.module';
import { AuthInterceptor } from '../modules/d2x-client/interceptors/auth.interceptor';
import { D2XAuthService } from '../modules/d2x-client/services/d2x-auth.service';
import { AuthApi } from '../modules/d2x-client/apis/auth.api';
import { environment } from '../environments/environment';


export function AuthApiFactory(httpClient: HttpClient) {
    return new AuthApi(httpClient, environment.pythonUrl);
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    StoreModule.forRoot({}, {}),
  ],
  providers: [
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    provideCharts(withDefaultRegisterables()),
    D2XAuthService,
    {
        provide: AuthApi,
        useFactory: AuthApiFactory,
        deps: [HttpClient]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
